export const animateValue = (obj: HTMLElement, start: number, end: number, duration: number) => {
    let startTimestamp: number | null = null

    const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp
        const progress = Math.min((timestamp - startTimestamp) / duration, 1)
        const sign = obj.getAttribute("data-sign")

        if (Number.isInteger(end)) {
            obj.innerHTML = Math.floor(progress * (end - start) + start).toLocaleString("en-US")
        } else {
            obj.innerHTML = (progress * (end - start) + start).toFixed(1)
        }

        if (sign) {
            obj.appendChild(document.createTextNode(sign))
        }

        if (progress < 1) {
            window.requestAnimationFrame(step)
        }
    }

    window.requestAnimationFrame(step)
}
